export default __webpack_public_path__ + "static/media/ic_south_africa.5931e998.svg";